enum RealtimeAPIEventTypeEnum {
  ExportLicenseDataResultNotification = 'ExportLicenseDataResultNotification',
  PartnerDeletedNotification = 'PartnerDeletedNotification',
  OrganizationsMovedNotification = 'OrganizationsMovedNotification',
  OrganizationArchivedNotification = 'OrganizationArchivedNotification',
  OrganizationRestoredNotification = 'OrganizationRestoredNotification',
}

export default RealtimeAPIEventTypeEnum;
